import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, Polyline, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-extra-markers/dist/css/leaflet.extra-markers.min.css';
import L from 'leaflet';
import 'leaflet-extra-markers';
import { renderToString } from 'react-dom/server';
import { MdSettingsInputAntenna } from 'react-icons/md';

// Helper function to calculate distance between two coordinates (Haversine formula)
const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const toRad = (value) => (value * Math.PI) / 180;
    const R = 6371; // Radius of the Earth in kilometers
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Distance in kilometers
};

const statusObject = {
    0: {
        color: 'red',
        description: 'fail'
    },
    1: {
        color: 'green',
        description: 'active'
    },
    2: {
        color: 'purple',
        description: 'init'
    },
    3: {
        color: 'orange',
        description: 'error'
    },
}

const UniqueDeviceMap = ({ center, zoom = 13, pointer, status = 'init', lrrs }) => {
    const mainMarkerIcon = L.ExtraMarkers.icon({
        markerColor: statusObject[status].color,
        shape: 'circle',
        prefix: 'fa',
    });

    useEffect(() => {
        console.log(status)
    }
        , [status])

    return (
        <MapContainer
            attributionControl={false}
            center={center}
            zoom={zoom}
            style={{ height: '500px', width: '100%', zIndex: 0 }}
        >
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />

            {/* Main Marker */}
            <Marker position={[pointer.latitude, pointer.longitude]} icon={mainMarkerIcon}>
                <Popup>Name: {pointer.name}</Popup>
            </Marker>

            {/* LRR Markers and Connecting Lines */}
            {lrrs &&
                lrrs.length > 0 &&
                lrrs.map((lrr, index) => {
                    const iconHTML = renderToString(<MdSettingsInputAntenna size={24} style={{ color: 'white' }} />);
                    const lrrMarkerIcon = L.divIcon({
                        className: 'custom-marker',
                        html: `
                            <div style="
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                width: 40px;
                                height: 40px;
                                border-radius: 50%;
                                background-color: blue;
                            ">
                                ${iconHTML}
                            </div>
                        `,
                        iconSize: [40, 40],
                    });

                    const distance = calculateDistance(
                        pointer.latitude,
                        pointer.longitude,
                        lrr.lat,
                        lrr.lon
                    ).toFixed(2); // Distance in kilometers

                    return (
                        <React.Fragment key={index}>
                            <Polyline
                                positions={[
                                    [pointer.latitude, pointer.longitude],
                                    [lrr.lat, lrr.lon],
                                ]}
                                color="gray"
                                weight={2}
                                pathOptions={{
                                    dashArray: '5, 10', // Pattern: 5 units dash, 10 units gap
                                }}
                            >
                                <Tooltip permanent>
                                    {distance} km
                                </Tooltip>
                            </Polyline>
                            <Marker position={[lrr.lat, lrr.lon]} icon={lrrMarkerIcon}>
                                <Popup>
                                    ID: {lrr.ID}
                                    <br />
                                    RSSI: {lrr.RSSI}
                                    <br />
                                    SNR: {lrr.SNR}
                                </Popup>
                            </Marker>
                        </React.Fragment>
                    );
                })}
        </MapContainer>
    );
};

export default UniqueDeviceMap;
